"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var color_1 = __importDefault(require("color"));
var styles = function (theme) {
    return (0, core_1.makeStyles)({
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: '1px',
            margin: '-1px',
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            width: '1px'
        },
        header: {
            paddingTop: theme.spacing(),
            paddingLeft: theme.spacing()
        },
        strength: {
            fontWeight: 'bold'
        },
        strong: {
            backgroundColor: theme.palette.success.main
        },
        medium: {
            backgroundColor: theme.palette.warning.main
        },
        weak: {
            backgroundColor: theme.palette.error.dark
        },
        strongBar: {
            backgroundColor: (0, color_1.default)(theme.palette.success.main).hex().getLowEmphasis()
        },
        mediumBar: {
            backgroundColor: (0, color_1.default)(theme.palette.warning.main).hex().getLowEmphasis()
        },
        weakBar: {
            backgroundColor: theme.palette.error.light.getLowEmphasis()
        },
        errorCheckbox: {
            color: theme.palette.success.main
        },
        errorCheckboxUncheck: {
            '& span': {
                color: theme.palette.error.light
            }
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map